import { render, staticRenderFns } from "./InvoiceConfigView.vue?vue&type=template&id=20cf1972&"
import script from "./InvoiceConfigView.vue?vue&type=script&lang=js&"
export * from "./InvoiceConfigView.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceConfigView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports